import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { I18nProvider } from '@fiverr-private/fiverr_context';
import { Switch, Tooltip } from '@fiverr-private/fit';
import { FilterContext } from '../../../../../../context/filterContext';
import { setCookie, expireCookie } from '../../../../../../../utils/cookies';
import { FILTER } from '../../../../../../../config/filters';
import { FILTERS_LOCATION } from '../../../../../../../utils/constants';
import ToggleTooltip from '../toggle/ToggleTooltip';

const { POSITIONS } = Tooltip;
import '../toggle/index.scss';

class BusinessProToggle extends PureComponent {
    constructor(props) {
        super(props);
        const { options = [] } = props;
        const { selected } = options[0] || false;

        this.state = {
            toggled: selected
        };

        this.onChange = this.onChange.bind(this);
    }
    static contextType = FilterContext;

    setProCookies = (newToggleValue) => {
        if (newToggleValue) {
            setCookie(FILTER.PRO.COOKIE_NAME, FILTER.PRO.SELECTED_VALUE);
        } else {
            expireCookie(FILTER.PRO.COOKIE_NAME);
        }
    }

    onChange = ({ target }) => {
        const { navigationCondition, applyNavigation, activeFilters } = this.context;
        const newValue = { [FILTER.PRO.ID] : target.checked ? FILTER.PRO.SELECTED_VALUE : undefined };

        this.setState((prevState) => {
            const newToggleValue = !prevState.toggled;
            this.setProCookies(newToggleValue);
            return { ...prevState, toggled: newToggleValue };
        });

        if (navigationCondition(newValue, activeFilters)) {
            const location = FILTERS_LOCATION.FLOATING_TOP;
            applyNavigation(newValue, activeFilters, location);
        }
    }

    render() {
        const { options = [], className } = this.props;
        const { selected } = options[0] || false;

        const translationPrefix = 'search_perseus.filters.global.proBusiness';
        const title = `${translationPrefix}.alias`;
        const text = `${translationPrefix}.text`;

        return (
            <I18nProvider>
                {({ i18n }) => (
                    <ToggleTooltip title={i18n.t(title)}
                        content={text && i18n.t(text)}
                        educationContent={text && i18n.t(text)}
                        position={POSITIONS.LEFT}
                        showNotification>
                        <div className={classNames('toggler-wrapper', 'business', className)}>
                            <Switch size={Switch.SIZES.SMALL} checked={this.state.toggled} value={selected} onChange={this.onChange}/>
                            {i18n.t(title)}
                        </div>
                    </ToggleTooltip>
                )}
            </I18nProvider>
        );
    }
}

BusinessProToggle.propTypes = {
    className: PropTypes.string,
    options: PropTypes.array
};

export default BusinessProToggle;
